var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "200px",
    width: "200px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 492.4 492.4",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4BD22"
    },
    d: "M184,392.8c-92.8,0-168-75.2-168-168s75.2-168,168-168s168,75.2,168,168S276.8,392.8,184,392.8z M184,92.8c-72.8,0-132,59.2-132,132s59.2,132,132,132s132-59.2,132-132S256.8,92.8,184,92.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEE76"
    },
    d: "M187.2,364.8c72.8,0,132-59.2,132-132c0-18.4-4-36-10.4-52c4.8,13.6,8,28.8,8,44 c0,72.8-59.2,132-132,132c-54.4,0-100.8-32.8-120.8-80C80.8,328,129.6,364.8,187.2,364.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEE76"
    },
    d: "M19.2,232.8c0-92.8,75.2-168,168-168c69.6,0,128.8,42.4,154.4,102.4c-24-64-85.6-110.4-157.6-110.4 c-92.8,0-168,75.2-168,168c0,23.2,4.8,45.6,13.6,65.6C23.2,272.8,19.2,252.8,19.2,232.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8991E"
    },
    d: "M184,56.8c-0.8,0-1.6,0-1.6,0v36c0,0,0.8,0,1.6,0c72.8,0,132,59.2,132,132s-59.2,132-132,132 c-0.8,0-1.6,0-1.6,0v36c0,0,0.8,0,1.6,0c92.8,0,168-75.2,168-168S276.8,56.8,184,56.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8991E"
    },
    d: "M189.6,443.2c-65.6-65.6-65.6-172,0-237.6s172-65.6,237.6,0s65.6,172,0,237.6 C362.4,508.8,255.2,508.8,189.6,443.2z M401.6,231.2c-51.2-51.2-135.2-51.2-186.4,0s-51.2,135.2,0,186.4s135.2,51.2,186.4,0 C453.6,365.6,453.6,282.4,401.6,231.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEE76"
    },
    d: "M212,424.8c51.2,51.2,135.2,51.2,186.4,0c12.8-12.8,22.4-28,28.8-44c-6.4,12.8-14.4,25.6-25.6,36.8 c-51.2,51.2-135.2,51.2-186.4,0c-38.4-38.4-48-94.4-28.8-142.4C163.2,324,171.2,384.8,212,424.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEE76"
    },
    d: "M186.4,212.8c65.6-65.6,172-65.6,237.6,0c48.8,48.8,61.6,120.8,36.8,181.6 c28.8-62.4,17.6-138.4-33.6-189.6c-65.6-65.6-172-65.6-237.6,0c-16.8,16.8-28.8,36-36.8,56C160.8,244,172,227.2,186.4,212.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8b3bed"
    },
    points: "221.6,0 244.8,27.2 184,80 123.2,27.2 146.4,0 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8b3bed"
    },
    points: "221.6,0 244.8,27.2 184,80 123.2,27.2 146.4,0 "
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#7c21ed"
    },
    points: "244.8,27.2 184,80.8 123.2,27.2 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8b3bed"
    },
    points: "221.6,0 220,25.6 184,80 150.4,24.8 146.4,0 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#700ced"
    },
    points: "221.6,0 220,25.6 184,3.2 150.4,24.8 146.4,0 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#5611ab"
    },
    points: "220,27.2 184,80.8 150.4,27.2 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#b484f0"
    },
    points: "135.2,27.2 184,80.8 123.2,27.2 146.4,0 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#5611ab"
    },
    points: "232.8,27.2 184,80.8 244.8,27.2 221.6,0 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRings);
export default __webpack_public_path__ + "static/media/rings.43f5fc4bc05fe533e3e077808587371f.svg";
export { ForwardRef as ReactComponent };